import "core-js/modules/es.array.push.js";
import api from "assets/js/public.js";
export default {
  data() {
    return {
      page: 1,
      list: []
    };
  },
  methods: {
    getList() {
      // @ts-ignore
      api.news({
        status: 0,
        pageNum: this.page,
        pageSize: 9
      }).then(res => {
        this.list = res.data.list;
      });
    },
    goDetail(item) {
      if (item.url && item.url.includes("http")) {
        window.open(item.url);
        return;
      }
      if (item.content) {
        this.$router.push({
          path: "/newDetail",
          query: {
            id: item.unid
          }
        });
      }
    }
  },
  created() {
    this.getList();
  }
};